var _path, _circle, _circle2, _path2, _path3, _circle3, _circle4, _circle5, _circle6, _circle7, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCefta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-cefta",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "M0 0h512v512H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 266.5,
    r: 32.5,
    fill: "none",
    stroke: "#fc0",
    strokeWidth: 29.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 266.5,
    r: 94.2,
    fill: "none",
    stroke: "#fc0",
    strokeWidth: 29.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "m346.3 176.1 90.3 90.3-90.3 90.3-90.3-90.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M102.1 251.8h63.2v29.3h-63.2zM378.5 251.8h94.2v29.3h-94.2zM301.9 199.9l41.3-41.3 20.7 20.7-41.3 41.3zM241.3 51.8h29.3V166h-29.3z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.8,
    cy: 170.3,
    r: 14.7,
    fill: "#fc0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.6,
    cy: 266.5,
    r: 14.7,
    fill: "#fc0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 406.8,
    r: 14.7,
    fill: "#fc0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 453.9,
    r: 14.7,
    fill: "#fc0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.2,
    cy: 266.5,
    r: 14.7,
    fill: "#fc0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m136.9 364.3 20.7-20.7 20.7 20.7-20.7 20.7zM355.4 386.6 376 366l20.7 20.7-20.7 20.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCefta);
export default __webpack_public_path__ + "static/media/cefta.8da776b129386e682cdad8ad352ad04d.svg";
export { ForwardRef as ReactComponent };